import * as React from "react";

const Icon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={50.415}
      height={35.001}
      {...props}
    >
      <path
        data-name="Path 33"
        d="M24.322 24.749L1.9 14.009v7.679l2.7 1.355.583-1.867a.956.956 0 011.182-.615 1.018 1.018 0 01.242.106l12.12 6.449a.908.908 0 01.484.875L19 30.434l5.321 2.4v-8.085zm1.231 9.983a.984.984 0 01-1.075.185l-6.811-3.073a.913.913 0 01-.62-.938l.226-2.486-10.6-5.642-.573 1.841a.8.8 0 01-.07.162.965.965 0 01-1.276.386L.591 23.082A.915.915 0 010 22.235v-9.7a.92.92 0 01.574-.839L23.834.098a.974.974 0 01.874 0l7.746 3.77h-.008.008l.025.012 7.919 3.849.025.012 7.9 3.841a.908.908 0 01.513.705v-.035L50.4 21.57a.9.9 0 01-.5.949L25.791 34.626a1.066 1.066 0 01-.238.106zM47.45 11.598l-8.965 4.665 7.373-3.837-5.863-2.845.435-.221-21.409 10.811 6.232 2.986L47.45 11.598zm-9.531-3.03l-5.876-2.856L9.108 17.043l1.666-.823 6.158 2.951-.431.217 21.418-10.82zm-7.968-3.87l-5.678-2.764L3.044 12.516l5.621 2.695-.431.213L29.951 4.698z"
        fill="#30698d"
      />
    </svg>
  );
}

export default Icon;
